function initCast() {
    const { Promise, IntersectionObserver, MedscapeTV, Medscape } = window;
    const CastEl = document.querySelector("[data-module='cast']");

    const { cast } = MedscapeTV;
    if (CastEl != null && cast.enable === true) {
        CastEl.classList.add("enable");
        const OBSERVER_OPTIONS = {
            rootMargin: '-30px',
            threshold: 0.1
        };
        let callback = function(entries, observer) {
            entries.forEach(entry => {
                //console.log("[LazyLoadModules][Cast] entry:", entry, "\nel:", entry.target);
                if (entry.isIntersecting === true) {

                    observer.disconnect();
                    const ReactPromise = import("react");
                    const ReactDomPromise = import("react-dom");
                    const AboutSeriesPromise = import('@medscape-promo/medscapetv/cast/cast.component');
                    const promises = [ReactPromise, ReactDomPromise, AboutSeriesPromise];
                    //console.log("[LazyLoadModules] Loading Cast", promises);
                    Promise.all(promises).then(modules => {
                        //console.log("[LazyLoadModules] Cast Promise:", modules);
                        const React = modules[0];
                        const ReactDOM = modules[1];
                        const { default: Cast } = modules[2];
                        const onReady = (store => {
                            window.MedscapeTV.stores = MedscapeTV.stores || {};
                            window.MedscapeTV.stores = Object.assign(MedscapeTV.stores, {
                                Cast: store
                            });
                            CastEl.classList.add('ready');

                        })
                        const props = {
                            medscape: Medscape,
                            config: cast,
                            onReady
                        }
                        ReactDOM.render(React.createElement(Cast, props), CastEl);

                    });


                }
            });
        };
        let observer = new IntersectionObserver(callback, OBSERVER_OPTIONS);
        observer.observe(CastEl);
    }
}
export default initCast;